export default async function DeleteOrgLevelApi(id) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/organization-levels/${id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
        console.log(response);
      })
      .catch((error) => {
        console.error("Error deleting organization: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
